import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Colors } from '@lichtblick/theme';
import { Text } from '../../atoms/Text/Text';
import { StyledStatusMessage } from './StatusMessage.styles';
const statusColorMap = {
    action: {
        backgroundColor: Colors.FadedAqua,
        color: Colors.Aqua
    },
    error: {
        backgroundColor: Colors.FadedRed,
        color: Colors.Red
    },
    info: {
        backgroundColor: Colors.BackgroundGray,
        color: Colors.DarkGray
    },
    success: {
        backgroundColor: Colors.FadedGreen,
        color: Colors.Green
    }
};
export const StatusMessage = ({ icon, message, status, type })=>{
    const { backgroundColor, color } = statusColorMap[status];
    return /*#__PURE__*/ _jsxs(StyledStatusMessage, {
        $backgroundColor: backgroundColor,
        $color: color,
        type: type,
        children: [
            icon,
            /*#__PURE__*/ _jsx(Text, {
                isBold: true,
                size: "S",
                children: message
            })
        ]
    });
};

//# sourceMappingURL=StatusMessage.js.map